import React from "react";
import "./style.css";
import { createSearchParams, useNavigate } from "react-router-dom";
const Category = ({ color, image, title, id }) => {
  const navigate = useNavigate();
  return (
    <div
      className="category columnDiv make_res_cat categoreyBox"
      style={{ cursor: "pointer" }}
      onClick={() => {
        navigate({
          pathname: "/Product",
          search: createSearchParams({ q: id }).toString(),
        });
        // navigate('/Product',{state:{id}});
      }}
    >
      {image && image?.length ? (
        <img
        className='cat_image'
          style={{ borderRadius: '15px' }}
          src={
            image.includes(".")
              ? image
              : require("../../assets/images/no_image.png")
          }
        />
      ) : null}
      <h5>{title}</h5>
    </div>
  );
};

export default Category;
